import { render, staticRenderFns } from "./StatsWidget.vue?vue&type=template&id=13ae1062&scoped=true&shadow"
import script from "./StatsWidget.vue?vue&type=script&lang=js&shadow"
export * from "./StatsWidget.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./StatsWidget.vue?vue&type=style&index=0&id=13ae1062&prod&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "13ae1062",
  null
  ,true
)

export default component.exports